var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v(" "+_vm._s(_vm.$store.state.last_refresh_time)+" ")]),_c('br'),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.__btn_test_click}},[_vm._v("测试")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }